import React, { useEffect, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Icon, Select, Tabs, message } from 'antd';
import * as palette from '../../styles/variables';
import { EMAIL_SETTINGS_TAB as trans } from '../SidebarMenu/translationValues';
import TemplateMenuItem from '../SidebarMenu/TemplateMenuItem';
import { withTranslation } from 'react-i18next';
import TextBlockWithQuillRenderer from '../ComplexDocumentDesign/TextBlockWithQuillRenderer';
import FontsProvider from '../../context/fontsContext';
import {
  constructQuillJSON,
  convertContractToReact,
} from '../../utils/TextBlockHelper';
import { patchEnvFromAddress, verifiedFromAddressList } from '../../utils/services/complexEmailAPI';
import {
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
  useDocumentContext,
} from '../../context/complexDocumentContext';
import ComplexPreviewModal from '../../components/Modals/ComplexPreviewModal';
import { COMPLEX_EMAIL_SETTINGS } from './translationValues';
import { COMPLEX_DOCUMENT_VERSION } from '../../utils/complexDocumentConstants';
import { COMPLEX_EMAIL_CONTEXT_KEYS, useEmailContext } from '../../context/complexEmailContext';
import { licenseDetails } from '../../utils/services/onPremAPI';
import { ENTERPRISE_ENV } from '../../utils/helper';
import { deepCopy } from '../../utils/javascript';

const PROTECTED = 'passwordProtected';
const NAMESPACE = ['EMAIL_SETTINGS_TAB'];
const { Option } = Select;
const { TabPane } = Tabs;

const dummyCallback = () => {};

const TabMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props.isSaveFolder ? '50px' : '150px')};
  margin-left: 75px;
  height: ${props => props.variableSidebar && '100%'};
  width: ${props => props.complexDesign && '90%'};
  margin: ${props => props.complexDesign && 'auto'};
  .addAttachmentsButton {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 500;
    border-radius: 15px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      background: ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
    }
  }
  &.mailSettings {
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    .ant-input {
      min-height: 55%;
      height: 70%;
      font-size: 15px;
    }
  }
  &.fixedHeight {
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    height: calc(100% - 60px);
  }
  .categoryContainer {
    margin-top: 88px;
    overflow: auto;
    max-height: 48vh;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    @media only screen and (max-width: 1440px) {
      max-height: 45vh;
    }
  }
  &.attachmentTemp {
    align-items: center;
    h2 {
      font-size: 16px !important;
      font-weight: 600;
    }
  }

  .manage-setting-input {
    margin-top: 10px;
    margin-bottom: 20px;
    height: 40px;
    i[aria-label='icon: search'] {
      display: none;
    }
  }
  .warning-message {
    color: orange;
    font-size: 14px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
`;

const TabMenuHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.inverted ? '#333' : '#fff')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: ${props =>
    props.subject ? '5px 0 0 0' : props.isImageCount ? '60px 10px 10px 10px' : '10px 10px 10px'};
  text-transform: uppercase;
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;
  &.categoryName {
    margin: 20px auto;
    &:before {
      content: '';
      display: block;
      width: 65px;
      height: 2px;
      background: #fff;
      left: 25px;
      top: 50%;
      position: absolute;
    }
    &:after {
      content: '';
      display: block;
      width: 65px;
      height: 2px;
      background: #fff;
      right: 25px;
      top: 50%;
      position: absolute;
    }
    h2 {
      font-size: 14px;
      font-weight: 700;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 10px 10px 10px;
      text-transform: capitalize;
      text-align: center;
      max-width: 115px;
      color: ${props => (props.inverted ? '#333' : '#ffffff')};
    }
  }
  .see-all {
    cursor: pointer;
    font-weight: 400;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const TabMenuItemContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.columnDirection ? 'column' : 'row')};
  flex-wrap: wrap;
  padding-right:0px !important;
  margin-bottom: ${props => (props.subject ? '0' : props.addAttachment ? '100px' : '10px')};
  margin-top: ${props => props.isSearchView && '80px'};
  position: relative;
  z-index: 101;
  justify-content: ${props => (props.justifyContent ? props.justifyContent : 'center')};
  align-items: ${props => (props.subject ? 'flex-start' : 'center')};
  
  .buttonItem {
    margin: 10px 0 0 10px;
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border: 1px solid rgba(14, 19, 24, 0.7);
    width: 70%;
    height: 50px;
    border-radius: 10px;
    
    .overflowText {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ant-select-selection {
    background-color: #fc6e511c;
    color: #fff;
    border: 1.9px solid hsla(0,0%,100%,0.4);  
    margin: 5px 0;
    font-size: 15px;
    font-weight: 600;
  }
  .ant-select-arrow {
    color: #fff !important;
  }
  .ant-select-selection:hover{
    border:1.5px solid #fff !important; 
  }
  .ant-select-selection:focus, .ant-select-selection:active {
    border-color: #fff;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: none !important;
  }  
  .ant-select-disabled .ant-select-selection {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #c7c7c7 !important;
    font-weight: 500 !important;
  }

  .subject-editor {
    width: 75%;
    border-radius: 4px;
    background-color: white !important;
    height: 32px;
    padding-top: 5px !important;
    padding-left: 10px !important;
  }

  #q-container-email-subject {
    cursor: not-allowed;
    .quill {
        pointer-events: none;
    }
  }
`;

const MailSettingsTab = styled.div`
  height: 61%;
  overflow: hidden;
  width: 75%;
  @media screen and (max-height: 640px) {
    height: 56%;
  }
  .ant-tabs-nav {
    color: rgb(255 255 255 / 0.65) !important;
    font-weight: 600 !important;
    .ant-tabs-tab-active {
      color: #ffffff !important;
      font-weight: 700 !important;
    }
    .ant-tabs-tab {
      &:active {
        color: #ffffff !important;
      }
      &:hover {
        color: #ffffff !important;
      }
    }
  }
  .ant-tabs-ink-bar {
    background-color: #ffffff !important;
  }
  .ant-tabs-bar {
    border-bottom: #ffffff00 !important;
  }
  .ant-tabs-nav-wrap {
    text-align: center;
  }
`;

const OverflowContainer = styled.div`
  height: calc(70vh - 60px);
  overflow: auto;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

const ComplexEmailEnvSettings = props => {
  const { readOnly, t, emailData = {}, currentEnv, setEnvEmailData } = props;
  const { attachments, subject, fromAddressId, documentId } = emailData;
  const [fromAddressList, setFromAddressList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(undefined);
  const [localFromAddressId, setLocalFromAddressId] = useState(fromAddressId);

  const emailConfiguredSelector = useCallback(store => store[COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_CONFIGURED], []);
  const [isEmailConfigured, emailMethods] = useEmailContext(emailConfiguredSelector, 'ComplexEmailMetaTab');

  useEffect(() => {
    if (fromAddressId || fromAddressId === 0) {
      setLocalFromAddressId(fromAddressId);
    }
  }, [fromAddressId]);

  const variablesSelector = useCallback(
    store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES],
    [],
  );
  const [globalVariables] = useDocumentContext(variablesSelector);

  useEffect(() => {
    (async () => {
          const response = await verifiedFromAddressList();
          const SMTPIds = response?.data || [];
          let fromAddressIds = [];
          if(ENTERPRISE_ENV && isEmailConfigured === null) {
            const licenseInfo = await licenseDetails();
            if(licenseInfo?.EmailConfiguration) {
              fromAddressIds = [{ id: 0, emailFromAddress: t(trans.EXTERNAL_DROPDOWN_OPTION.key, trans.EXTERNAL_DROPDOWN_OPTION.value) }, ...SMTPIds];
            } else {
              fromAddressIds = SMTPIds;
            }
            emailMethods.set({
              [COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_CONFIGURED]: licenseInfo?.EmailConfiguration
            });
          } else if(ENTERPRISE_ENV && isEmailConfigured) {
            fromAddressIds = [{ id: 0, emailFromAddress: t(trans.EXTERNAL_DROPDOWN_OPTION.key, trans.EXTERNAL_DROPDOWN_OPTION.value) }, ...SMTPIds];
          } else {
            fromAddressIds = SMTPIds;
          }
          setFromAddressList(fromAddressIds);
        })();
  }, []);

  const previewSAttachmentTemplate = useCallback((e, templateObj) => {
    e.stopPropagation();
    setSelectedTemplate(templateObj);
  }, []);

  const changeFromAddress = useCallback(
    async value => {
      let env = 'testing';
      if (currentEnv === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
        env = 'published';
      }
      // TODO : Check if publishing cycle should be invoked or alert should be shown like existing module
      const response = await patchEnvFromAddress(documentId, value, env);
      if (response.statusCode === 3111) {
        message.success(
          t(
            `COMPLEX_EMAIL_SETTINGS:${COMPLEX_EMAIL_SETTINGS.UPDATE_FROM_ADDRESS_SUCCESS.key}`,
            COMPLEX_EMAIL_SETTINGS.UPDATE_FROM_ADDRESS_SUCCESS.value,
          ),
        );
        const copyEmailData = deepCopy(emailData);
        copyEmailData.fromAddressId = value;
        setEnvEmailData(copyEmailData);
      } else {
        message.error(
          t(
            `COMPLEX_EMAIL_SETTINGS:${COMPLEX_EMAIL_SETTINGS.UPDATE_FROM_ADDRESS_FAILURE.key}`,
            COMPLEX_EMAIL_SETTINGS.UPDATE_FROM_ADDRESS_FAILURE.value,
          ),
        );
      }
    },
    [documentId, currentEnv],
  );

  const convertedSubject = subject?.contents;

  return (
    <>
      <TabMenuContainer className="mailSettings">
        {(localFromAddressId || localFromAddressId === 0) && (
          <TabMenuItemContainer columnDirection={true} subject={1}>
            <TabMenuHeader subject={1}>
              {' '}
              {t(trans.SEND_EMAIL_FROM_LABEL.key, trans.SEND_EMAIL_FROM_LABEL.value)}{' '}
            </TabMenuHeader>
            <Select
              defaultValue={localFromAddressId}
              style={{ width: '75%' }}
              value={localFromAddressId}
              onChange={changeFromAddress}
            >
              {fromAddressList.map(smtp => {
                return <Option value={smtp.id}>{smtp.emailFromAddress}</Option>;
              })}
            </Select>
          </TabMenuItemContainer>
        )}
        {subject?.contents && (
          <TabMenuItemContainer columnDirection={true} subject={1}>
            <TabMenuHeader subject={1}>
              {' '}
              {t(trans.SUBJECT_OF_EMAIL_LABEL.key, trans.SUBJECT_OF_EMAIL_LABEL.value)}{' '}
            </TabMenuHeader>
            <div id="email-subject-toolbar" style={{ visibility: 'hidden', height: 0 }} />
            <div id="email-subject-variable" style={{ position: 'relative', top: 10 }} />
            <FontsProvider>
              <TextBlockWithQuillRenderer
                defaultContent={constructQuillJSON(convertedSubject, null, null, globalVariables)}
                itemUUID={`email-subject`}
                selected={false}
                editable={false}
                enableSideBar={dummyCallback}
                enableAI={false}
                toolbarInvisible={true}
                adjustScroll={dummyCallback}
                toolbarDOM={'email-subject-toolbar'}
                variableDOM={'email-subject-variable'}
                customClassName={'subject-editor'}
                textEditable={false}
                setTextEditable={() => {}}
                isPreview={true}
              >
                {convertContractToReact(convertedSubject, null, null, globalVariables)}
              </TextBlockWithQuillRenderer>
            </FontsProvider>
          </TabMenuItemContainer>
        )}
        <MailSettingsTab>
          {attachments && attachments.length > 0 && (
            <Tabs defaultActiveKey="1">
              {attachments.filter(attachment => attachment.contentType === 'document').length && (
                <TabPane tab="Attachments" key="1">
                  <OverflowContainer>
                    <TabMenuItemContainer addAttachment={true}>
                      {attachments
                        .filter(attachment => attachment.contentType === 'document')
                        .map(templateObj => {
                          return (
                            <TemplateMenuItem
                              key={templateObj.id}
                              templateObj={templateObj}
                              onMenuClick={() => {}}
                              onPreviewClick={e => previewSAttachmentTemplate(e, templateObj)}
                              showCheckbox={false}
                              checkboxValue={templateObj[PROTECTED]}
                              noCarousel
                            />
                          );
                        })}
                    </TabMenuItemContainer>
                  </OverflowContainer>
                </TabPane>
              )}
              {attachments.filter(attachment => attachment.contentType !== 'document').length && (
                <TabPane tab="Files" key="2">
                  <OverflowContainer>
                    <TabMenuItemContainer>
                      {attachments
                        .filter(attachment => attachment.contentType !== 'document')
                        .map(attachment => (
                          <div
                            className={'buttonItem'}
                          >
                            <Icon type={'file-pdf'} />
                            <span className={'overflowText'}> {attachment.documentName} </span>
                            {!readOnly && (
                              <Icon
                                type={'delete'}
                                onClick={e => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                }}
                              />
                            )}
                          </div>
                        ))}
                    </TabMenuItemContainer>
                  </OverflowContainer>
                </TabPane>
              )}
            </Tabs>
          )}
        </MailSettingsTab>
      </TabMenuContainer>

      {selectedTemplate && (
        <ComplexPreviewModal
          visible={true}
          onCancel={() => setSelectedTemplate(undefined)}
          type={'document'}
          templateId={selectedTemplate?.documentId}
          reusableFlow={selectedTemplate?.isStandalone}
        />
      )}
    </>
  );
};

export default withTranslation(NAMESPACE)(ComplexEmailEnvSettings);
